export class ComingSoon {
  constructor() {}

  comingSoonId: string;
  name: string;
  picture: string;
  description: string;
  releaseDate: string;
}



// WEBPACK FOOTER //
// ./src/data/ComingSoon.ts